module.exports = __webpack_public_path__ + "img/maPread_logo_color.847fe13a.svg";